import { get } from 'lodash'

import routes from 'router/routes'
import { createDrawerRouterSlice, getInitialDrawerRouterState } from 'slices/generic/createDrawerRouterSlice'

import type { PayloadAction } from '@reduxjs/toolkit'

type NotificationDrawerState = {
  notificationDrawer?: {
    isDrawerOpen?: boolean
    favoriteUrl?: string
  }
}

/** `createDrawerRouterSlice` is untyped JS, so the generated actions are declared here. */
type NotificationDrawerActions = {
  openDrawer: () => PayloadAction<undefined>
  closeDrawer: () => PayloadAction<undefined>
  setIsDrawerOpen: (isOpen: boolean) => PayloadAction<boolean>
  setFavoriteUrl: (url: string) => PayloadAction<string>
}

export const notificationDrawerSlice = createDrawerRouterSlice({
  name: 'notificationDrawer',
  initialState: getInitialDrawerRouterState({ favoriteUrl: routes.app.notifications }),
  reducers: {},
})

export const { openDrawer, closeDrawer, setIsDrawerOpen, setFavoriteUrl } =
  notificationDrawerSlice.actions as unknown as NotificationDrawerActions

export const selectIsNotificationDrawerOpen = (state: NotificationDrawerState) => get(state, 'notificationDrawer.isDrawerOpen', true)

export const selectNotificationFavoriteUrl = (state: NotificationDrawerState) =>
  get(state, 'notificationDrawer.favoriteUrl', routes.app.notifications)

export default notificationDrawerSlice.reducer
